// extracted by mini-css-extract-plugin
export default {"row":"UfoButtonSection_row__z2nxf","margin":"UfoButtonSection_margin__Cuzhy"};